import 'css-chunksrc/client/common/filterMenu/projectPortfolios/portfolios/styles.scss';export default {
  "project": "_project_7t379_1",
  "name": "_name_7t379_11"
};